import React from 'react'

import { AppOfficesBlock } from '@components'
import AppSearchesProgressCard from './ProgressCard'


export default function AppReportSearchesOfficesModalBlock({ isLoading, officesData }) {

	const { completedPercentage, totalPercentage, officesInfo } = officesData || {}

	return <AppSearchesProgressCard
		icon="plane-departure"
		title="By office"
		isLoading={isLoading}
		current={completedPercentage}
		total={totalPercentage}
		rows={(officesInfo || []).filter(({ total }) => !!total).map(({ name, country, type, current, total }, idx) => ({
			key: idx,
			current,
			total,
			label: <AppOfficesBlock
				name={name}
				country={country}
				type={type}
				sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontWeight: 400, fontSize: 13 }}
			/>,
		}))}
	/>
}
